module.exports = __webpack_public_path__ + "img/instagram.edec8ac4.svg";